import React from 'react';
import PropTypes from 'prop-types';
import {
  Step,
  StepNumber,
  StepContent,
  StepContentTitle,
  StepContentText,
  StartButton,
  Image
} from 'products/nomad_insurance/views/Profile/ClaimsOld/styled';
import stepOneImage from 'products/nomad_insurance/assets/img/claims/step-one-copy.svg';

const StepOne = ({ showStartButton }) => {
  return (
    <Step>
      <StepNumber>
        <span>1</span>
      </StepNumber>
      <StepContent>
        <Image>
          <img src={stepOneImage} alt="Illustration of claim form" />
        </Image>
        <StepContentTitle>Submit claim form and documents</StepContentTitle>
        <StepContentText>
          Attach necessary documents by clicking on the paperclip icon{' '}
          <span role="img" aria-label="paperclip">
            📎
          </span>
        </StepContentText>
        <StepContentText>
          If you are filing a medical claim, make sure to attach <br />
          (a) your medical report (a note from your doctor which include symptoms,
          diagnosis and treatment), <br />
          (b) a detailed invoice outlining what you paid for and (c) proof of payment or
          receipt. Provide the policy number you are claiming under. See your receipts tab
          to see all previous policies.
        </StepContentText>
        {showStartButton && (
          <StartButton
            onClick={() =>
              window.open(
                'https://powerforms.docusign.net/661ffbab-979e-4a17-9b5c-2f392cdcfb6c?env=na2&acct=7276ba92-91bc-477e-9e09-e0c472fc38a8&accountId=7276ba92-91bc-477e-9e09-e0c472fc38a8',
                '_blank',
                'noopener'
              )
            }
          >
            Start
          </StartButton>
        )}
      </StepContent>
    </Step>
  );
};

StepOne.propTypes = {
  showStartButton: PropTypes.bool
};

export default StepOne;
